module.exports = __webpack_public_path__ + "static/media/web_corkboard_title_tornpaper.b87c4cbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web_corkboard_title_tornpaper.png
// module id = 206
// module chunks = 0